import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";
import axios from "axios";
import {components} from "react-select";

const SelectAsyncPaginate = (props) => {
  const [coinName, setCoinName] = useState(null);
  const [coinList,setCoinList] = useState([])
    const [symbols,setSymbols] = useState([])
    const { SingleValue, Option } = components;



  useEffect(() => {
    setCoinName(props.coinName);
  }, [props.coinName]);

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
      setCoinList([])
      if(coinList.length>0)
      {
        setCoinList([])
      }

    const response =  await axios.get('https://api.sinatether.com/Auth/GetDupCoins/', {
                params: {"curr": coinName}
            }).then((res) => {
                if (res.status == 200) {
                    setSymbols(res.data['listSym'])
                    coinList.push({label: "تومان", value: "IR",image: `Coinsimg/IR.png`})
                    res.data['list'].map((data) => (
                        coinList.push({label: data['label'], value: data['value'],image: `Coinsimg/${data['value']}.png`})


                    ))


                }
            })

    return {
      options: coinList,
      hasMore: false,
      additional: {
        page: searchQuery ? 2 : page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
      symbols.map((sym)=>{
          if (sym['quoteCurrency'] == option['value'])
          {
               let bIncrement = sym['baseIncrement'].split('.')[1]
               let qIncrement = sym['quoteIncrement'].split('.')[1]
               props.setBaseIncrement(bIncrement.length)
               props.setQuoteIncrement(qIncrement.length)


          }
      })
    }
  };


  const IconSingleValue2 = (props) => (
    <SingleValue {...props}>
        <img src={props.data.image} alt='' className="img64213"/>
        <span className={'text-medium pl-1 mytx6464'}>{props.data.label}</span>
        <span className={'text-medium text-price pl-2 mytx6464'}>{props.data.value}</span>
    </SingleValue>
);

const IconOption2 = (props) => (
    <Option {...props}>
        <img src={props.data.image} alt='' className="img64213"/>
        <span className={'text-medium pl-1 mytx6464'}>{props.data.label}</span>
        <span className={'text-medium text-price pl-2 mytx6464'}>{props.data.value}</span>

    </Option>
);


  return (
    <AsyncPaginate
      styles={props.styles}
      key={JSON.stringify(coinName)}
      value={props.value || ""}
      components={{
          SingleValue: IconSingleValue2,
          Option: IconOption2
      }}
      loadOptions={loadOptions}
      getOptionValue={(option) => option.value}
      getOptionLabel={(option) => option.value}
      onChange={onChange}
      isSearchable={false}
      defaultValue={coinList[0]}
      additional={{
        page: 1,
      }}
      noOptionsMessage={() => "هیج موردی یافت نشد"}
      loadingMessage ={() => "درحال بارگیری..."}
      
    />
  );
};

SelectAsyncPaginate.propTypes = {
  coinName: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export default SelectAsyncPaginate;
